import { NgxsModuleOptions } from '@ngxs/store';

// NGXS 18 flipped both selector defaults to false. Our selectors were written against the NGXS 3
// behaviour (container state injected, TypeErrors on missing slices swallowed), so keep it.
export const NGXS_OPTIONS: NgxsModuleOptions = {
    selectorOptions: {
        injectContainerState: true,
        suppressErrors: true,
    },
};
